import styled from 'styled-components'

export const TurnstileTooltipWrapper = styled.div(() => ({
  pointerEvents: 'auto',
  maxWidth: '250px',
}))
